<template>
    <div class="bo-cell-toggle">
        <label class="switch">
            <input type="checkbox" v-model="toggleStatus" :disabled="!visibile" />
            <span class="slider round"></span>
        </label>
    </div>
</template>

<script>
var config = require('../../../../../config/roles/capabilitiesMapping.json');
var pluralize = require('../../../pluralize.js');

export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        editable: {
            type: Boolean,
            default: true,
        },
        record: {
            type: [Array, Object],
            default: [],
        },
        column: {
            type: [Array, Object],
            default: [],
        },
    },
    computed: {
        toggleStatus: {
            get() {
                let text = this.column.id+'_'+this.record.resource.replace(/ /g,"_").toLowerCase();
                let condition = text.startsWith("enable") ? config[text] : pluralize(text);
                if (this.record.capability_value && Object.values(this.record.capability_value).indexOf(condition) > -1) {
                    return true;
                }
                return false;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },

        visibile: {
            get() {
                    if(this.column.id == 'create' && this.record._create) {
                        return true;
                    } else if(this.column.id == 'update' && this.record._update) {
                        return true;
                    } else if(this.column.id == 'read' && this.record._read) {
                        return true;
                    }
                    else if(this.column.id == 'delete' && this.record._delete) {
                        return true;
                    }  else if(this.column.id == 'enable' && this.record._enable) {
                        return true;
                    } else{
                        return false;
                    }
                }
            },

        },
};
</script>
